export enum QueryParamsEnum {
  FCM_TOKEN = 'org:vendorflow:fcm:registration',
  OS_PUSH_ALLOWED = 'org:vendorflow:native:push-allowed',
  REDIRECT_TO_CHANNEL = 'redirectToChannel',
  REDIRECTED = 'redirected',
}
